module.exports = __webpack_public_path__ + "img/icon-file.8e43b003.svg";